export default {
  GET_EVENTS: "GET_EVENTS",
  ADD_OR_UPDATE_EVENT: "ADD_OR_UPDATE_EVENT",
  DELETE_EVENT: "DELETE_EVENT",
  UPDATE_SELECTED_BOAT_IDS: "UPDATE_SELECTED_BOAT_IDS",
};
